/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssignedAt } from './AssignedAt';
import {
    AssignedAtFromJSON,
    AssignedAtFromJSONTyped,
    AssignedAtToJSON,
} from './AssignedAt';
import type { CompletedAt2 } from './CompletedAt2';
import {
    CompletedAt2FromJSON,
    CompletedAt2FromJSONTyped,
    CompletedAt2ToJSON,
} from './CompletedAt2';
import type { StartedAt1 } from './StartedAt1';
import {
    StartedAt1FromJSON,
    StartedAt1FromJSONTyped,
    StartedAt1ToJSON,
} from './StartedAt1';
import type { SubmittedAt } from './SubmittedAt';
import {
    SubmittedAtFromJSON,
    SubmittedAtFromJSONTyped,
    SubmittedAtToJSON,
} from './SubmittedAt';

/**
 * Lightweight visit form summary for list endpoints.
 * @export
 * @interface VisitFormListItem
 */
export interface VisitFormListItem {
    /**
     * Visit form UUID
     * @type {string}
     * @memberof VisitFormListItem
     */
    id: string;
    /**
     * Property address
     * @type {string}
     * @memberof VisitFormListItem
     */
    propertyAddress: string;
    /**
     * Current section number
     * @type {number}
     * @memberof VisitFormListItem
     */
    currentSection: number;
    /**
     * Visit form status
     * @type {string}
     * @memberof VisitFormListItem
     */
    status: string;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof VisitFormListItem
     */
    createdAt: Date;
    /**
     * Last update timestamp
     * @type {Date}
     * @memberof VisitFormListItem
     */
    updatedAt: Date;
    /**
     * 
     * @type {AssignedAt}
     * @memberof VisitFormListItem
     */
    assignedAt?: AssignedAt;
    /**
     * 
     * @type {StartedAt1}
     * @memberof VisitFormListItem
     */
    startedAt?: StartedAt1;
    /**
     * 
     * @type {CompletedAt2}
     * @memberof VisitFormListItem
     */
    completedAt?: CompletedAt2;
    /**
     * 
     * @type {SubmittedAt}
     * @memberof VisitFormListItem
     */
    submittedAt?: SubmittedAt;
}

/**
 * Check if a given object implements the VisitFormListItem interface.
 */
export function instanceOfVisitFormListItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "propertyAddress" in value;
    isInstance = isInstance && "currentSection" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function VisitFormListItemFromJSON(json: any): VisitFormListItem {
    return VisitFormListItemFromJSONTyped(json, false);
}

export function VisitFormListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisitFormListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'propertyAddress': json['property_address'],
        'currentSection': json['current_section'],
        'status': json['status'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'assignedAt': !exists(json, 'assigned_at') ? undefined : AssignedAtFromJSON(json['assigned_at']),
        'startedAt': !exists(json, 'started_at') ? undefined : StartedAt1FromJSON(json['started_at']),
        'completedAt': !exists(json, 'completed_at') ? undefined : CompletedAt2FromJSON(json['completed_at']),
        'submittedAt': !exists(json, 'submitted_at') ? undefined : SubmittedAtFromJSON(json['submitted_at']),
    };
}

export function VisitFormListItemToJSON(value?: VisitFormListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'property_address': value.propertyAddress,
        'current_section': value.currentSection,
        'status': value.status,
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
        'assigned_at': AssignedAtToJSON(value.assignedAt),
        'started_at': StartedAt1ToJSON(value.startedAt),
        'completed_at': CompletedAt2ToJSON(value.completedAt),
        'submitted_at': SubmittedAtToJSON(value.submittedAt),
    };
}

